import {useState, useEffect, useCallback, useRef} from "react";
import {useParams} from 'react-router-dom';
import {onlineProcessesService, userService} from "../../services";
import {useLoader} from "@quadral/quadral-component-common/dist/components/loader/LoaderContext";
import QuadralTabPanel from '@quadral/quadral-component-common/dist/components/tabPanel';
import QuadralToast, {quadralToast} from '@quadral/quadral-component-common/dist/components/toast';
import QuadralBadge from "@quadral/quadral-component-common/dist/components/badge"
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container"
import QuadralTextField from "@quadral/quadral-component-common/dist/components/textField";
import QuadralTypography from "@quadral/quadral-component-common/dist/components/typography";
import QuadralList from "@quadral/quadral-component-common/dist/components/list";
import QuadralButton from "@quadral/quadral-component-common/dist/components/button";
import QuadralAutocomplete from "@quadral/quadral-component-common/dist/components/autocomplete";
import QuadralTooltip from "@quadral/quadral-component-common/dist/components/tooltip";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Details from "./Details";
import IncomeAndExpenses from "./IncomeAndExpenses";
import SupportingDocuments from './supportingDocument/SupportingDocuments';
import PersonList from "./PersonList";
import Activities from "./Activities";
import NewActivityModal from './NewActivityModal';

import {useKeycloak} from '@react-keycloak/web';
import ParticipationValidationModal from "./ParticipationValidationModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faBan, 
    faCheck, 
    faMagnifyingGlass, 
    faCirclePause, 
    faEnvelope, 
    faFileInvoice, 
    faFileLines, 
    faUser, 
    faXmark, 
    faExclamationTriangle, 
    faInfoCircle, 
    faUsers, 
    faEuroSign, 
    faChartColumn, 
    faCalendarDays, 
    faClockRotateLeft,
    faPhone, 
    faClipboard,
    faTriangleExclamation,
    faThumbsUp,
    faWarning,
} from "@fortawesome/free-solid-svg-icons";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import Assistance from "./Assistance";


const SurveyParticipation = () => {
    const timeoutRef = useRef(null);
    const searchContainerRef = useRef(null);
    const {keycloak} = useKeycloak();
    const roles = keycloak.tokenParsed?.realm_access?.roles || [];
    const user = keycloak.tokenParsed?.email || keycloak.tokenParsed?.preferred_username;

    const [searchValue, setSearchValue] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const [statuses, setStatuses] = useState();
    const [supportingDocuments, setSupportingDocuments] = useState([]);

    const {participationId} = useParams();
    const [participation, setParticipation] = useState(null);
    const [persons, setPersons] = useState([]);
    const [personIds, setPersonIds] = useState([]);
    const [signatoryPerson, setSignatoryPerson] = useState();
    const [references, setReferences] = useState([]);
    const {showLoader, hideLoader} = useLoader();
    const [tabValue, setTabValue] = useState(getInitialTabValue());
    const [canUpdate, setCanUpdate] = useState(false);
    const [docsPerPerson, setDocsPerPerson] = useState([])

    const [participationVerified, setParticipationVerified] = useState(false);
    const [isTerminationModalOpen, setIsTerminationModalOpen] = useState(false);

    const [activitiesOrAssistances, setActivitiesOrAssistances] = useState(true)
    const [activityRecords, setActivityRecords] = useState();
    const [activityOrder, setActivityOrder] = useState('DESC');
    const [assistanceRecords, setAssistanceRecords] = useState();
    const [assistanceOrder] = useState('DESC');
    const [assistanceType, setAssistanceType] = useState('');
    const [deviationId, setDeviationId] = useState(null);
    const [surveyDetails, setSurveyDetails] = useState(null);
    const isN2 = roles.includes("survey-participation.deviation2");
    const isN3 = roles.includes("survey-participation.deviation3");
    const specialActionStatusesDeviation3 = ['controle_en_cours', 'complements_attendu', 'complements_fournis', 'reponse_validee', 'controlee'];
    const specificN3Action = specialActionStatusesDeviation3.includes(participation?.status);

    const [updatedData, setUpdatedData] = useState(0);
    const [updateRecords, setUpdateRecords] = useState(0);
    const [updatedParticipation, setUpdatedParticipation] = useState(0);

    const documentStatusOptions = [
        {
            label: "A fournir",
            value: "a_fournir",
        },{
            label: "Validé",
            value: "valide",
        },{
            label: "Refusé",
            value: "refuse",
        }
    ]

    const typeOptions = [
        {   label: 'Toutes les activités',    value: '', },
		{   label: 'Appels',    value: 'Call', },
        {   label: 'Tâches',    value: 'Task'},
		{   label: 'Emails',    value: 'Email', },
		{   label: 'Journaux',    value: 'logs', }
    ];

    const STATUS_COLOR_MAP = {
        "controle_en_cours": 'control',
        "en_attente_des_pj": 'warning',
        "complements_attendu": 'warning',
        "en_attente_de_lancement": 'info',
        "en_attente_de_connexion": 'info',
        "en_attente_reponse": 'info',
        "premier_courrier_recu": 'info',
        "complements_fournis": 'info',
        "controlee": 'success',
        "reponse_validee": 'yellow',
        "annulee": 'secondary',
    };

    const STATUS_ICON_MAP = {
        "controle_en_cours": faFileLines,
        "en_attente_des_pj": faCirclePause,
        "complements_attendu": faFileLines,
        "en_attente_de_lancement": faCirclePause,
        "en_attente_de_connexion": faUser,
        "en_attente_reponse": faFileLines,
        "premier_courrier_recu": faFileLines,
        "complements_fournis": faFileLines,
        "controlee": faThumbsUp,
        "reponse_validee": faCheck,
        "annulee": faBan,
    };

    function getTypeIcon(type) {
        switch (type) {
            case "Call":
                return faPhone;
            case "Email":
                return faEnvelope;
            case "Task":
                return faClipboard;
            case "logs":
                return faFileLines;
            case "Escalade":
                return faTriangleExclamation;
            default:
                return faCheck;
        }
    };

    function getTypeColor(type) {
        switch (type) {
            case "Call":
                return 'success';
            case "Email":
                return 'info';
            case "Task":
                return 'info';
            case "logs":
                return 'warning';
            case "Escalade":
                return 'warning';
            default:
                return 'secondary';
        }
    };

    const DEVIATION_STATUS_MAP = {
        Escalade_interne: 'Escaladé interne',
		Escalade_externe: 'Escaladé mandant' ,
        Retours_a_analyser_interne: 'Retours à analyser - interne' ,
		Retours_a_analyser_externe: 'Retours à analyser - mandant' ,
        Traite: 'Traité' ,
    }

    const DEVIATION_STATUS_COLOR_MAP = {
        Escalade_interne: 'warning',
        Escalade_externe: 'warning',
        Retours_a_analyser_interne: 'info',
        Retours_a_analyser_externe: 'info',
        Traite: 'success',
        
// ↓↓ Evolution des couleurs éventuelles à prévoir selon les retours de l'équipe métier ↓↓

        // Escalade_interne: 'purple',
        // Escalade_externe: 'purple',
        // Retours_a_analyser_interne: 'coral',
        // Retours_a_analyser_externe: 'coral',
        // Traite: 'teal',

// ↑↑ Evolution des couleurs éventuelles à prévoir selon les retours de l'équipe métier ↑↑

    }

    const DEVIATION_STATUS_ICON_MAP = {
        Escalade_interne: faExclamationTriangle,
        Escalade_externe: faExclamationTriangle,
        Retours_a_analyser_interne: faInfoCircle,
        Retours_a_analyser_externe: faInfoCircle,
        Traite: faCheck,
    }

    const fastSearchColumns = [
        {
            id: "label",
            label: "Nom de la participation",
        },
    ];

    const refreshPersonsData = useCallback(
        async function refreshPersonsData() {
            showLoader();
            onlineProcessesService.getPersonRecords(participationId)
                .then(dataReceived => {
                    setPersons(dataReceived);
                    hideLoader();
                })
                .catch(err => {
                    console.error(err);
                    hideLoader();
                });
        }, [participationId, showLoader, hideLoader]
    )

    function getInitialTabValue(){
        const currentParticipationId = localStorage.getItem(`currentParticipationId`);
        if (currentParticipationId === participationId) {
            const savedTab = localStorage.getItem(`currentTab`);
            return savedTab;
        }else{
            localStorage.setItem(`currentParticipationId`, participationId);
            return '1';
        }
    }

    useEffect(() => {
        localStorage.setItem(`currentTab`, tabValue);
    }, [tabValue]);

    useEffect(() => {
        refreshPersonsData();
    }, [participationId, refreshPersonsData])

    useEffect(() => {
        userService.hasRole('survey-participation.write').then(hasRole => setCanUpdate(hasRole));
    }, []);

    useEffect(() => {
        const statusCount = {
            a_fournir: 0,
            attente_verification: 0,
            valide: 0,
            refuse: 0
        }

        supportingDocuments?.forEach((doc) => {
            if(doc.status && statusCount.hasOwnProperty(doc.status)){
                statusCount[doc.status]++;
            }
        });

        setStatuses(statusCount);
    }, [supportingDocuments]);

    function updateRecord(){
        setUpdateRecords(updateRecords + 1)
    }

    useEffect(()=>{
        const ids = [...new Set(persons.map(p => p.id))]
        setPersonIds(ids)
    },[persons])

    useEffect(() => {
        showLoader();
        onlineProcessesService.getSurveyParticipationById(participationId)
            .then((response) => {
                setParticipation(response);
                hideLoader();
            })
            .catch(err => {
                console.error(err);
                hideLoader();
            });
    }, [participationId, showLoader, hideLoader, updatedParticipation]);

    useEffect(() => {
        setDeviationId(participation?.deviationId ?? null);
    }, [participation])

    useEffect(() => {
        setParticipationVerified(participation?.status === 'reponse_validee');
    }, [participation?.status]);

    useEffect(() => {
        onlineProcessesService.getSignatoryPersonRecords(participationId)
            .then(dataReceived => {
                setSignatoryPerson(dataReceived[0]);
            })
            .catch(err => {
                console.error(err);
            });
    }, [participationId])

    useEffect(() => {
        onlineProcessesService.getReferences().then(refs => {
            setReferences(refs || {});
        });
    }, [participationId]);

    useEffect(() => {
        if (participation?.surveyId) {
            onlineProcessesService.getSurveyDetails(participation.surveyId)
                .then(data => setSurveyDetails(data))
                .catch(err => console.error(err));
        }
    }, [participation?.surveyId]);

    useEffect(() => {
        const fetchDocuments = async () => {
            const results = Object.fromEntries(
                (
                    await Promise.all(
                        personIds.map(async personId => {
                            const data = await onlineProcessesService.getSupportingDocuments(
                                participation?.id,
                                personId
                            );

                            const counts = data.reduce((acc, item) => {
                                acc[item.statusLabel] = (acc[item.statusLabel] || 0) + 1;
                                return acc;
                            }, {});

                            return [personId, counts];
                        })
                    )
                )
            );
            setDocsPerPerson(results)
        };

        if (participation?.id && personIds?.length) {
            fetchDocuments();
        }
    }, [updatedData, participation?.id, personIds]);

    useEffect(() => {
        showLoader();
        if (!participationId) return;
        const body={
            participationId:participationId,
            subtype:assistanceType,
            orderByDate:activityOrder,
        }
        onlineProcessesService.getActivityRecords({participationId}, body)
            .then(dataReceived => {
                setActivityRecords(dataReceived);
                hideLoader();
            })
            .catch(err => {
                console.error(err);
                hideLoader();
            });
    }, [participationId, updateRecords, assistanceType, activityOrder, showLoader, hideLoader]);
    
    useEffect(() => {
        const body={
            participationId:participationId,
            orderByDate:assistanceOrder,
        }
        onlineProcessesService.getAssistanceRecords({participationId}, body)
            .then(dataReceived => setAssistanceRecords(dataReceived))
            .catch(err => {
                console.error(err);
            });
    }, [participationId, updateRecords, assistanceOrder])

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    function formatDate(date){
        if(!date) return "inconnue";
        const formatedDate = new Date(date);
        if(isNaN(formatedDate)) return "invalide";

        return formatedDate.toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    }          

    function updateData(){
        setUpdatedData(updatedData + 1)
    }

    function updateParticipation(){
        setUpdatedParticipation(updatedParticipation + 1)
    }

    function mapReferences(value, reference) {
        const list = references?.[reference] || [];
        return list?.find(item => item.code === value)?.label || value;
    };

    function mapReferenceToOptions(refKey) {
        return references?.[refKey]?.map(item => ({
            code: item.code,
            label: item.label
        })) || [];
    }

    function handleTabs(event, newValue) {
        if (newValue !== tabValue) setTabValue(newValue);
    };

    function getDocStatus(statusCode) {
        const reference = documentStatusOptions.find(option => option.value === statusCode);
        return reference ? reference.label : statusCode
    }

    function getDocStatusIcon(statusCode) {
        if (statusCode) {
            switch (statusCode) {
                case 'valide' :
                    return <FontAwesomeIcon icon={faCheck}/>
                case 'refuse' :
                    return <FontAwesomeIcon icon={faXmark}/>
                default :
                    return <FontAwesomeIcon icon={faFileInvoice}/>
            }
        }
    }

    function getDocStatusCount(statusCode) {
        return statuses?.[statusCode] ?? 0;
    }

    const closeSearchVignette = useCallback(() => {
        setIsSearchFocused(false);
    }, []);

    const handleSearch = (value) => {
        setSearchValue(value);
        setIsSearchFocused(true);
        
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (!value) {
            setSearchResults([]);
            return;
        }

        timeoutRef.current = setTimeout(() => {
            onlineProcessesService
                .searchSurveyParticipations({
                    surveyId: isN2 ? undefined : participation?.surveyId,
                    contractCode: value
                })
                .then((res) => {
                    const results = res?.surveyParticipations || [];
                    setSearchResults(results);
                })
                .catch((err) => {
                    console.error(err);
                    setSearchResults([]);
                });
        }, 600);
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!searchContainerRef.current) return;
            if (searchContainerRef.current.contains(event.target)) return;

            closeSearchVignette();
        };

        document.addEventListener('mousedown', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, [closeSearchVignette]);

    function calculateDaysUntilClosing(endDate) {
        if (!endDate) return null;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const closingDate = new Date(endDate);
        closingDate.setHours(0, 0, 0, 0);
        const daysRemaining = Math.ceil((closingDate - today) / (1000 * 60 * 60 * 24));
        return daysRemaining > 0 ? daysRemaining : 0;
    }

    function getClosingBadgeColor(daysRemaining) {
        if (daysRemaining < 30) return 'error';
        if (daysRemaining < 60) return 'warning';
        return 'success';
    }

    return (
        <div className="page-content">
            <QuadralToast/>
            <ParticipationValidationModal
                open={isTerminationModalOpen}
                setOpen={setIsTerminationModalOpen}
                statuses={statuses}
                getDocStatusCount={getDocStatusCount}
                getDocStatusIcon={getDocStatusIcon}
                getDocStatus={getDocStatus}
                participation={participation}
                showLoader={showLoader}
                hideLoader={hideLoader}
                setParticipationVerified={setParticipationVerified}
                updateParticipation={updateParticipation}
                participationVerified={participationVerified}
                quadralToast={quadralToast}
            />
            <QuadralContainer orientation='column' sx={{gap: '1rem', paddingBottom: '0.5rem'}}>
                <div
                    ref={searchContainerRef}
                    onFocusCapture={() => setIsSearchFocused(true)}
                    onBlurCapture={(event) => {
                        const nextFocused = event.relatedTarget;
                        if (searchContainerRef.current?.contains(nextFocused)) return;
                        closeSearchVignette();
                    }}
                    style={{ position: "relative", maxWidth: "300px", width: "100%" }}
                >
                    <QuadralTextField
                        style={{ backgroundColor: "#fff" }}
                        innerStyle={{ fontSize: "12px" }}
                        fullWidth
                        sx={{ marginBottom: 0 }}
                        value={searchValue}
                        onChange={handleSearch}
                        startIcon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                        placeholder="Rechercher par code contrat"
                        noPadding
                        noMargin
                    />

                    {isSearchFocused && searchValue.length > 5 && (
                        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, maxHeight: "300px", overflowY: "auto", zIndex: 1000}}>
                            {searchResults.length > 0 ? (
                                <QuadralList 
                                    headless
                                    columns={fastSearchColumns} 
                                    rows={searchResults.map((result) => ({ 
                                        label: (<>
                                            {result.surveyStatus !== 'en_cours' &&
                                                <QuadralTooltip 
                                                    placement='top' 
                                                    title={<>
                                                        <QuadralTypography variant='dataValue' sx={{color: 'white'}}>Attention</QuadralTypography><br/>
                                                        <QuadralTypography variant='normal' sx={{color: 'white'}}>Cette participation est rattachée à une enquête passée. A priori elle ne doit pas être modifiée.</QuadralTypography>
                                                    </>}
                                                >
                                                    <QuadralBadge
                                                        label={surveyDetails?.endDate ? `Ancienne (${surveyDetails.endDate.slice(0, 4)})` : 'Ancienne'}
                                                        color='warning'
                                                        icon={<FontAwesomeIcon icon={faWarning}/>}
                                                    />
                                                </QuadralTooltip> 
                                            }
                                            <QuadralTypography> {`${result.lastname} ${result.firstname} - ${result.contractCode}`} </QuadralTypography>
                                        </>), 
                                        link: `/enquetes/${result.surveyId}/participations/${result.id}`, }
                                    ))} 
                                />
                            ) : (
                                <QuadralList columns={fastSearchColumns} rows={[{ label: `Aucun résultat trouvé` }]} headless/>
                            )}
                        </div>
                    )}
                </div>
                <QuadralContainer orientation='row' style={{ display: 'flex', gap: '0.75rem', marginBottom: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                    <QuadralTypography variant='title' sx={{whiteSpace: 'nowrap', flexShrink: 0}}>{`${participation?.firstname} ${participation?.lastname} - ${participation?.name}`}</QuadralTypography>
                    <QuadralBadge
                        label={<QuadralTypography variant='titleComplement'>{participation?.contractCode}</QuadralTypography>}
                        color="secondary"
                        // style={{color:'#000', textTransform: 'capitalize'}}
                        sx={{
                            bgcolor: "#EEF2FF",
                            borderRadius: "10px",
                            fontWeight: 500,
                            fontSize: 14,
                            height: 40,
                        }}
                    />
                    {surveyDetails?.surveyStatus !== 'en_cours' &&
                        <QuadralTooltip 
                            placement='top' 
                            title={<>
                                <QuadralTypography variant='dataValue' sx={{color: 'white'}}>Attention</QuadralTypography><br/>
                                <QuadralTypography variant='normal' sx={{color: 'white'}}>Cette participation est rattachée à une enquête passée. A priori elle ne doit pas être modifiée.</QuadralTypography>
                            </>}
                        >
                            <QuadralBadge
                                label={<>Ancienne{surveyDetails?.endDate && <> ({surveyDetails.endDate.slice(0, 4)}) </>} <FontAwesomeIcon icon={faCircleQuestion}/></>}
                                color='warning'
                                icon={<FontAwesomeIcon icon={faWarning}/>}
                            />
                        </QuadralTooltip> 
                    }
                    {(participation?.communicationChannel) &&
                        <QuadralBadge
                            label={participation.communicationChannel}
                            color="secondary"
                            style={{color:'#000', textTransform: 'capitalize'}}
                            icon={
                                <FontAwesomeIcon icon={participation.communicationChannel === 'email' ? faEnvelope : faFileLines}/>
                            }
                        />
                    }
                    { (participation?.status) &&
                        <QuadralBadge
                            label={mapReferences(participation.status, "SURVEY_PARTICIPATION_STATUS")}
                            // participation.statusLabel === "Non accessible" || participation.statusLabel === "Statut inconnu" ? mapReferences(participation.status, "SURVEY_PARTICIPATION_STATUS") : participation.statusLabel}
                            color={STATUS_COLOR_MAP[participation.status] ?? 'info'}
                            icon={<FontAwesomeIcon icon={STATUS_ICON_MAP[participation.status] ?? faFileLines}/>}
                        /> 
                    }
                    { (participation?.deviationStatus) &&
                        <QuadralBadge
                            label={`Escalade : ${DEVIATION_STATUS_MAP[participation.deviationStatus] ?? participation.deviationStatus}`}
                            color={DEVIATION_STATUS_COLOR_MAP[participation.deviationStatus] ?? 'info'}
                            icon={<FontAwesomeIcon icon={DEVIATION_STATUS_ICON_MAP[participation.deviationStatus] ?? faFileLines}/>}
                        />
                    }
                    { surveyDetails?.endDate &&
                        (() => {
                            const daysRemaining = calculateDaysUntilClosing(surveyDetails.endDate);
                            return daysRemaining !== null ? (
                                <QuadralBadge
                                    label={`J-${daysRemaining} avant clôture`}
                                    color={getClosingBadgeColor(daysRemaining)}
                                    icon={<FontAwesomeIcon icon={faCalendarDays}/>}
                                />
                            ) : null;
                        })()
                    }
                </QuadralContainer>
            </QuadralContainer>
            <Tabs
                value={tabValue}
                onChange={handleTabs}
            >
                <Tab value="1" label="Synthèse" iconPosition="start" icon={<FontAwesomeIcon icon={faChartColumn}/>}/>
                <Tab value="2" label="Personnes" iconPosition="start" icon={<FontAwesomeIcon icon={faUsers}/>}/>
                <Tab value="3" label="Revenus et prestations" iconPosition="start" icon={<FontAwesomeIcon icon={faEuroSign}/>}/>
                <Tab value="4" label="Pièces justificatives" iconPosition="start" icon={<FontAwesomeIcon icon={faFileLines}/>}/>
                <Tab value="5" label="Activités et assistance" iconPosition="start" icon={<FontAwesomeIcon icon={faClockRotateLeft}/>}/>
            </Tabs>
            <QuadralTabPanel value={tabValue} index={"1"}> 
                <Details
                    showLoader={showLoader}
                    hideLoader={hideLoader}
                    roles={roles}
                    isN3={isN3}
                    signatoryPerson={signatoryPerson}
                    participation={participation}
                    bailleur={participation?.companyLabel}
                    persons={persons}
                    getDocStatusCount={getDocStatusCount}
                    mapReferences={mapReferences}
                    mapReferenceToOptions={mapReferenceToOptions}
                    setTabValue={setTabValue}
                    refreshPersonsData={refreshPersonsData}
                    formatDate={formatDate}
                    quadralToast={quadralToast}
                    activityRecords={activityRecords}
                    getTypeColor={getTypeColor}
                    getTypeIcon={getTypeIcon}
                    surveyDetails={surveyDetails}
                />
            </QuadralTabPanel>
            <QuadralTabPanel value={tabValue} index={"2"} sx={{padding: '1.5rem 0.25rem 1.5rem 0.25rem !important'}}>
                <PersonList 
                    showLoader={showLoader}
                    hideLoader={hideLoader}
                    participationId={participationId}
                    participation={participation}
                    persons={persons}
                    roles={roles}
                    isN3={isN3}
                    mapReferenceToOptions={mapReferenceToOptions}
                    refreshPersonsData={refreshPersonsData}
                    quadralToast={quadralToast}
                    docsPerPerson={docsPerPerson}
                /> 
            </QuadralTabPanel>
            <QuadralTabPanel value={tabValue} index={"3"}> 
                <IncomeAndExpenses
                    references={references}
                    showLoader={showLoader}
                    hideLoader={hideLoader}
                    participationId={participationId}
                    participation={participation}
                    personIds={personIds}
                    quadralToast={quadralToast}
                    updateData={updateData}
                    updateParticipation={updateParticipation}
                    roles={roles}
                    isN3={isN3}
                />
            </QuadralTabPanel>
            <QuadralTabPanel value={tabValue} index={"4"} style={{height: '95vh'}}>
                <SupportingDocuments 
                    setSupportingDocuments={setSupportingDocuments}
                    participation={participation}
                    persons={persons}
                    personIds={personIds}
                    showLoader={showLoader}
                    hideLoader={hideLoader}
                    id={participationId}
                    updatedData={updatedData}
                    updateData={updateData}
                    getDocStatusCount={getDocStatusCount}
                    participationVerified={participationVerified}
                    roles={roles}
                    isN3={isN3}
                    specificN3Action={specificN3Action}
                    canUpdate={canUpdate}
                    references={references}
                    quadralToast={quadralToast}
                    setIsTerminationModalOpen={setIsTerminationModalOpen}
                />
            </QuadralTabPanel>
            <QuadralTabPanel value={tabValue} index={"5"}>
                <QuadralContainer orientation='row' sx={{paddingBottom: '0.5rem'}}>
                    <QuadralContainer orientation='row' sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                        <QuadralButton
                            label='Activités'
                            color={activitiesOrAssistances ? 'primary' : 'secondary'}
                            size="small"
                            style={{ padding: '0.825rem 2rem', borderRadius: '1rem' }}
                            onClick={() =>
                                setActivitiesOrAssistances(true)
                            }
                        />
                        <QuadralButton
                            label='Assistances'
                            color={activitiesOrAssistances ? 'secondary' : 'primary'}
                            size="small"
                            style={{ padding: '0.825rem 2rem', borderRadius: '1rem' }}
                            onClick={() =>
                                setActivitiesOrAssistances(false)
                            }
                        />
                    </QuadralContainer>
                    <QuadralContainer 
                        orientation='right' 
                        sx={{
                            display: 'flex', 
                            gap: "1rem", 
                            alignItems: 'center', 
                            marginBottom: '1rem',
                            opacity: activitiesOrAssistances ? 1 : 0,
                            visibility: activitiesOrAssistances ? 'visible' : 'hidden',
                            transition: 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out',
                            pointerEvents: activitiesOrAssistances ? 'auto' : 'none',
                        }}
                    >
                        <div style={{minWidth: '14.5rem'}}>
                            <QuadralAutocomplete
                                value={typeOptions.find(o => o.value === assistanceType) ?? null}
                                onChange={(event, newValue) => {
                                    setAssistanceType(newValue?.value ?? "")
                                }}
                                // label="Type d'activité"
                                options={typeOptions}
                                getOptionLabel = {(option) => option?.label ?? ""}
                                fullWidth
                                noMargin
                            />
                        </div>
                        <NewActivityModal
                            roles={roles}
                            user={user}
                            updateRecord={updateRecord}
                            updateParticipation={updateParticipation}
                            participationId={participationId}
                            deviationId={deviationId}
                            quadralToast={quadralToast}
                            showLoader={showLoader}
                            hideLoader={hideLoader}
                        />
                    </QuadralContainer>
                </QuadralContainer>
                {activitiesOrAssistances ? (
                    <Activities
                        participationId={participationId}
                        quadralToast={quadralToast}
                        deviationId={deviationId}
                        roles={roles}
                        user={user}
                        formatDate={formatDate}
                        showLoader={showLoader}
                        hideLoader={hideLoader}
                        updateRecord={updateRecord}
                        setActivityOrder={setActivityOrder} 
                        setAssistanceType={setAssistanceType}
                        assistanceType={assistanceType} 
                        activityRecords={activityRecords} 
                        getTypeColor={getTypeColor}
                        getTypeIcon={getTypeIcon}
                    />
                ) : (
                    <Assistance
                        participationId={participationId}
                        quadralToast={quadralToast}
                        deviationId={deviationId}
                        roles={roles}
                        user={user}
                        formatDate={formatDate}
                        showLoader={showLoader}
                        hideLoader={hideLoader}
                        updateRecord={updateRecord}
                        updateParticipation={updateParticipation}
                        assistanceRecords={assistanceRecords}
                        getTypeColor={getTypeColor}
                        getTypeIcon={getTypeIcon}
                    />
                )}
            </QuadralTabPanel>
        </div>
    );
};

export default SurveyParticipation;